import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtINR, fmtDateTime, API_BASE } from "@/lib/api";

export default function ReceiptView() {
  const { id } = useParams();
  const [r, setR] = useState(null);

  useEffect(() => { api.get(`/receipts/${id}`).then((res) => setR(res.data)); }, [id]);

  if (!r) return <div className="text-slate-500">Loading…</div>;

  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <div className="bg-white rounded-2xl border border-slate-200 p-8">
        <div className="text-xs font-semibold uppercase tracking-wider text-blue-700 bg-blue-50 inline-block px-3 py-1 rounded-full">Receipt</div>
        <div className="mt-3 text-3xl font-extrabold mono">{r.receipt_no}</div>
        <div className="mt-1 text-slate-500">Issued {fmtDateTime(r.created_at)}</div>
        <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
          <div><span className="text-slate-400">Customer</span><div className="font-semibold">{r.customer_name}</div></div>
          <div><span className="text-slate-400">Mobile</span><div className="font-semibold">{r.mobile}</div></div>
          <div><span className="text-slate-400">Branch</span><div className="font-semibold">{r.branch_name}</div></div>
          <div><span className="text-slate-400">Vehicle</span><div className="font-semibold">{r.vehicle_model || "-"}</div></div>
        </div>

        <div className="mt-6 border-t border-slate-100 pt-4">
          <div className="text-xs uppercase text-slate-400 tracking-wider mb-2">Payments</div>
          {r.payments.map((p, i) => (
            <div key={`${p.mode}-${p.reference_no || ""}-${i}`} className="flex justify-between py-1 text-sm">
              <span>{p.mode} {p.reference_no && <span className="text-slate-400">· {p.reference_no}</span>}</span>
              <span className="mono font-semibold">{fmtINR(p.amount)}</span>
            </div>
          ))}
          <div className="flex justify-between border-t border-slate-100 mt-2 pt-2 text-base font-extrabold">
            <span>Total</span><span className="mono">{fmtINR(r.total_amount)}</span>
          </div>
        </div>

        <a href={`${API_BASE}/receipts/${r.id}/pdf`} target="_blank" rel="noreferrer" className="mt-6 inline-block px-4 py-2.5 rounded-xl bg-blue-600 text-white font-semibold text-sm">Open PDF</a>
      </div>
    </div>
  );
}
